/** Evenly spaced section links pinned under the site header. */
export default function DetailTabs({ items = [], label }) {
  if (items.length === 0) return null;
  return (
    <nav
      aria-label={label}
      className="sticky top-[57px] z-40 -mx-4 mt-5 border-y border-black/[0.08] bg-[#F9F9F9]/95 px-1 backdrop-blur-xl dark:border-white/[0.10] dark:bg-[#141312]/95 sm:-mx-6"
    >
      <div className="mx-auto flex max-w-[760px]">
        {items.map((item) => (
          <a
            key={item.id}
            href={`#${item.id}`}
            className="flex-1 whitespace-nowrap py-3 text-center text-[10px] font-extrabold uppercase tracking-[0.1em] text-[#6d6d6a] transition-colors hover:text-[#171717] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#171717] dark:text-[#c5c1b8] dark:hover:text-white"
          >
            {item.label}
          </a>
        ))}
      </div>
    </nav>
  );
}